import React from 'react';
import Gallery from '../components/Gallery';
import { filmMakingImages } from '../data/images';

const FilmMaking = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Film Making</h1>
          <p>
            Complete film making services from concept to final production, creating cinematic masterpieces for any occasion. 
            From short films to documentaries, we bring your vision to life on screen.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={filmMakingImages} sectionId="film-making" />
        </div>
      </section>

    </div>
  );
};

export default FilmMaking;
